<template>
	<v-dialog v-model="dialog" persistent max-width="700px">
		<v-card>
			<div class="mt-1">
				<v-alert
					:value="true"
					color="info"
					icon="warning"
				>
					Czy chcesz powiadomić sekretarza o tym, że ocena została niewłaściwie przypisana?
				</v-alert>
			</div>
			<v-card-actions>
				<v-spacer/>
				<v-btn color="blue"
					@click="closeDialog">
					Anuluj
				</v-btn>
				<v-btn color="blue darken-1"
					flat
					@click="sendNotification">
					Tak
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
	import {EvaluationNotification} from "@/api/generated/EvaluationNotification";
	import {AgencyEvaluationNotification} from "@/api/generated/AgencyEvaluationNotification";

	export default {
		name: "InappropriateAssignmentNotificationConfirmation",

		data () {
			return {
				dialog: true
			};
		},

		methods: {
			closeDialog () {
				this.$emit("close-dialog");
			},

			sendNotification () {
				if (['FORMAL_EVALUATION', 'SUBSTANTIVE_EVALUATION', 'EXPERT_EVALUATION', 'AGENCY_EVALUATION','FINAL_EVALUATION'].includes(this.evaluationType)) {
					EvaluationNotification.postInappropriateAssignmentNotification(this, {
						id: this.evaluation.id,
						contestId: this.evaluation.contestId,
						contestName: this.evaluation.contestName,
						offerTitle: this.evaluation.offerTitle,
            offerCode: this.evaluation.offerCode,
						evaluationType: this.evaluationType
					}, successResponse => {
						this.$emit("sent-inappropriate-assignment");
						this.$messagesBus.$emit("success", "Powiadomienie zostało wysłane", successResponse);
					}, errorResponse => {
						this.$messagesBus.$emit("error", "Nie udało się wysłać powiadomienia", errorResponse);
					});
				} else if (['AGENCY_SUBSTANTIVE_EVALUATION', 'AGENCY_EXPERT_EVALUATION', 'AGENCY_FINAL_EVALUATION'].includes(this.evaluationType)) {
					AgencyEvaluationNotification.postInappropriateAssignmentNotification(this, {
						id: this.evaluation.id,
						contestId: this.evaluation.contestId,
						contestName: this.evaluation.contestName,
						agencyProjectTitle: this.evaluation.agencyProjectTitle,
            agencyProjectCode: this.evaluation.agencyProjectCode,
						evaluationType: this.evaluationType
					}, successResponse => {
						this.$emit("sent-inappropriate-assignment");
						this.$messagesBus.$emit("success", "Powiadomienie zostało wysłane", successResponse);
					}, errorResponse => {
						this.$messagesBus.$emit("error", "Nie udało się wysłać powiadomienia", errorResponse);
					});
				}
			}
		},

		props: {
			evaluation: Object,
			evaluationType: String
		}
	};
</script>

<style scoped>

</style>
